import { render, staticRenderFns } from "./HazardAnalysisBtn.vue?vue&type=template&id=272725a3&scoped=true&"
import script from "./HazardAnalysisBtn.vue?vue&type=script&lang=js&"
export * from "./HazardAnalysisBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272725a3",
  null
  
)

export default component.exports